module.exports = __webpack_public_path__ + "img/mobile/General/stest@3x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/General/stest@3x.png
// module id = 195
// module chunks = 0